import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import { READ, Om7Sense as p } from './Om7Sense';

import { ReportingPageTabs } from './ReportingComponents/ReportingPageTabs.js';
import { useLocation, useMatch } from "react-router-dom-v5-compat";
import { TranslationContext } from "./hooks/useTranslationContext";
import { ApiConnectionContext } from "./hooks/useApiConnectionContext";

export const EventReportTab = () => {

    const { p, loggedInAs } = useContext(ApiConnectionContext);
    const permission = useMemo(() => p.checkPermission(READ, "/api/notification/get"), [ p, loggedInAs ]);

    const t = useContext(TranslationContext);

    const startDate = dayjs().utc(true).startOf('month').toISOString();

    const location = useLocation();

    return (
        <React.Fragment>
            <ReportingPageTabs location={location} />
            { !permission ? (
                <div className="empty">
                    <div className="empty-icon">
                        <i className="icon icon-people"></i>
                    </div>
                    <p className="empty-title h5">{ t("reporting.no_permission") }</p>
                </div>
            ) : ( 
                <div className="content overview reports">
                    <div className="columns">
                        <div className="col-3 col-sm-6 col-xs-12">
                            <Link className="btn btn-primary" to={"/report/events?type=THR&title=" + encodeURI(t("reporting.rcm_report")) + "&subType=ResidualCurrent,ResidualCurrentDC,ResidualCurrentAC&start=" + startDate} target="blank">{t("reporting.rcm_report")}</Link>
                        </div>
                        <div className="col-3 col-sm-6 col-xs-12">
                            <Link className="btn btn-primary" to={"/report/events?type=THR&title=" + encodeURI(t("reporting.all_thresholds_report")) + "&start=" + startDate} target="blank">{t("reporting.all_thresholds_report")}</Link>
                            <br />
                        </div>
                        <div className="col-3 col-sm-6 col-xs-12">
                            <Link className="btn btn-primary" to={"/report/events?type=LOGIN&title=" + encodeURI(t("reporting.login_report")) + "&start=" + startDate} target="blank">{t("reporting.login_report")}</Link>
                            <br />
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};